const settingsCv3ukapp = {
  'merchant.master_key': '',
  'autoupdate.check_frequency': '86400000',
  'autoupdate.enabled': true,
  'autoupdate.s3-bucket-name': 'aibms',
  'autoupdate.s3-endpoint': 'kineticsmart.com',
  'autoupdate.s3-prefix': 'files/kinetic_go/production/pp/uk/vega3000',
  'device.name': '',
  'device.show_name': false,
  'footer.line1': '',
  'footer.line2': '',
  'footer.line3': '',
  'footer.line4': '',
  'footer.line5': '',
  'gsm.apn': '',
  'header.line1': '',
  'header.line2': '',
  'header.line3': '',
  'header.line4': '',
  'header.line5': '',
  'merchant.cashback': true,
  'merchant.cashback_limit': 10000,
  'merchant.client_verification_manual': 'both',
  'merchant.client_verification_swiped': 'none',
  'merchant.country': 'gb',
  'merchant.country_code': '0826',
  'merchant.currency': 'gbp',
  'merchant.currency_code': '0826',
  'merchant.currency_symbol': '£',
  'merchant.industry': 'retail',
  'merchant.logon': false,
  'merchant.manual_limit': 9999999,
  'merchant.merchantid': '',
  'merchant.printable_lines': '15',
  'merchant.process_port': '46463',
  'merchant.process_url': 'ssl9.tnsi.eu.com',
  'merchant.prompt_reference': false,
  'merchant.support_email': 'support@paymentplus.co.uk',
  'merchant.support_phone': '0808 169 1616',
  'merchant.swipe_limit': 9999999,
  'merchant.terminal_capabilities': "'contact_emv','mag_stripe','manual_entry','pinpad','response_addl_data','contactless_mag_stripe','contactless_emv','contactless_cdcvm','contactless_signature'",
  'merchant.terminalid': '',
  'merchant.tip_enabled': false,
  'terminal.remove_card_sound': true,
  'terminal.debug': false,
  'terminal.host': 'aibms',
  'terminal.logo': 'logo_pp_320x60',
  'timezone.region': 'GB-London'
}

const settingsCv3ppukapp = {
  'merchant.master_key': '',
  'autoupdate.check_frequency': '86400000',
  'autoupdate.enabled': true,
  'autoupdate.s3-bucket-name': 'aibms',
  'autoupdate.s3-endpoint': 'kineticsmart.com',
  'autoupdate.s3-prefix': 'files/kinetic_go/production/pp/uk/vega3000',
  'device.name': '',
  'device.show_name': false,
  'footer.line1': '',
  'footer.line2': '',
  'footer.line3': '',
  'footer.line4': '',
  'footer.line5': '',
  'gsm.apn': '',
  'header.line1': '',
  'header.line2': '',
  'header.line3': '',
  'header.line4': '',
  'header.line5': '',
  'merchant.cashback': false,
  'merchant.cashback_limit': 10000,
  'merchant.client_verification_manual': 'both',
  'merchant.client_verification_swiped': 'none',
  'merchant.country': 'gb',
  'merchant.country_code': '0826',
  'merchant.currency': 'gbp',
  'merchant.currency_code': '0826',
  'merchant.currency_symbol': '£',
  'merchant.force_return_to_idle': true,
  'merchant.industry': 'retail',
  'merchant.logon': false,
  'merchant.manual_limit': 9999999,
  'merchant.merchantid': '',
  'merchant.printable_lines': '15',
  'merchant.process_port': '46463',
  'merchant.process_url': 'ssl9.tnsi.eu.com',
  'merchant.prompt_reference': false,
  'merchant.support_email': 'support@paymentplus.co.uk',
  'merchant.support_phone': '0808 169 1616',
  'merchant.swipe_limit': 9999999,
  'merchant.terminal_capabilities': "'contact_emv','mag_stripe','manual_entry','pinpad','response_addl_data','contactless_mag_stripe','contactless_emv','contactless_cdcvm','contactless_signature'",
  'merchant.terminalid': '',
  'merchant.tip_enabled': false,
  'terminal.printer': false,
  'terminal.remove_card_sound': true,
  'terminal.debug': false,
  'terminal.host': 'aibms',
  'terminal.logo': 'logo_pp_320x60',
  'timezone.region': 'GB-London'
}

const settingsCv3amtukpp = {
  "merchant.master_key": "",
  "auth.clear_password": "eposamt",
  "auth.password": "C206407F7C1A3852BBB8914FCF668FC2F48F1E85BBC4FDD0D99E4F6092BCFF7F",
  "auth.user": "amtpos",
  "autoupdate.check_frequency": "86400000",
  "autoupdate.enabled": true,
  "autoupdate.s3-bucket-name": "aibms",
  "autoupdate.s3-endpoint": "kineticsmart.com",
  "autoupdate.s3-prefix": "files/kinetic_go/production/pp/uk/vega3000",
  "device.name": "",
  "device.show_name": false,
  "eth0.dhcp.enabled": true,
  "eth0.dns_ip": "8.8.8.8",
  "eth0.static.gateway": "192.168.1.254",
  "eth0.static.ip": "192.168.1.20",
  "eth0.static.netmask": "255.255.255.0",
  "footer.line1": "",
  "footer.line2": "",
  "footer.line3": "",
  "footer.line4": "",
  "footer.line5": "",
  "gsm.apn": "m2m.tns.int1",
  "header.line1": "",
  "header.line2": "",
  "header.line3": "",
  "header.line4": "",
  "header.line5": "",
  "merchant.cashback": false,
  "merchant.cashback_limit": 10000,
  "merchant.client_verification_manual": "both",
  "merchant.client_verification_swiped": "none",
  "merchant.country": "gb",
  "merchant.country_code": "0826",
  "merchant.currency": "gbp",
  "merchant.currency_code": "0826",
  "merchant.currency_symbol": "£",
  "merchant.force_return_to_idle": true,
  "merchant.industry": "retail",
  "merchant.logon": false,
  "merchant.manual_limit": 9999999,
  "merchant.merchantid": "",
  "merchant.printable_lines": "15",
  "merchant.process_port": "46463",
  "merchant.process_url": "ssl9.tnsi.eu.com",
  "merchant.prompt_reference": false,
  "merchant.support_email": "support@paymentplus.co.uk",
  "merchant.support_phone": "0808 169 1616",
  "merchant.swipe_limit": 9999999,
  "merchant.terminal_capabilities": "'contact_emv','mag_stripe','manual_entry','pinpad','response_addl_data','contactless_mag_stripe','contactless_emv','contactless_cdcvm','contactless_signature'",
  "merchant.terminalid": "",
  "merchant.tip_enabled": true,
  "merchant.autotip_enabled": true,
  "merchant.autotip_percentage": "5",
  "merchant.autotip_prompt": "How was your service? Would you like to add a 5% tip?",
  "merchant.refund": false,
  "terminal.printer": true,
  "terminal.remove_card_sound": true,
  "terminal.debug": false,
  "terminal.host": "aibms",
  "terminal.logo": "logo_pp_320x60",
  "timezone.region": "GB-London"
}

const settingsCmp200ukapp = {
  'merchant.master_key': '',
  'autoupdate.check_frequency': '86400000',
  'autoupdate.enabled': true,
  'autoupdate.s3-bucket-name': 'aibms',
  'autoupdate.s3-endpoint': 'kineticsmart.com',
  'autoupdate.s3-prefix': 'files/kinetic_go/production/pp/uk/mp200',
  'device.name': '',
  'device.show_name': false,
  'footer.line1': '',
  'footer.line2': '',
  'footer.line3': '',
  'footer.line4': '',
  'footer.line5': '',
  'gsm.apn': '',
  'header.line1': '',
  'header.line2': '',
  'header.line3': '',
  'header.line4': '',
  'header.line5': '',
  'merchant.cashback': true,
  'merchant.cashback_limit': 10000,
  'merchant.client_verification_manual': 'both',
  'merchant.client_verification_swiped': 'none',
  'merchant.country': 'gb',
  'merchant.country_code': '0826',
  'merchant.currency': 'gbp',
  'merchant.currency_code': '0826',
  'merchant.currency_symbol': '£',
  'merchant.industry': 'retail',
  'merchant.logon': false,
  'merchant.manual_limit': 9999999,
  'merchant.merchantid': '',
  'merchant.printable_lines': '15',
  'merchant.process_port': '46463',
  'merchant.process_url': 'ssl9.tnsi.eu.com',
  'merchant.prompt_reference': false,
  'merchant.support_email': 'support@paymentplus.co.uk',
  'merchant.support_phone': '0808 169 1616',
  'merchant.swipe_limit': 9999999,
  'merchant.terminal_capabilities': "'contact_emv','mag_stripe','manual_entry','pinpad','response_addl_data','contactless_mag_stripe','contactless_emv','contactless_cdcvm','contactless_signature'",
  'merchant.terminalid': '',
  'merchant.tip_enabled': false,
  'terminal.remove_card_sound': true,
  'terminal.debug': false,
  'terminal.host': 'aibms',
  'terminal.logo': 'logo_pp_320x60',
  'timezone.region': 'GB-London'
}

const settingsCmp200gbapp = {
  'merchant.master_key': '',
  'autoupdate.check_frequency': '86400000',
  'autoupdate.enabled': false,
  'autoupdate.s3-endpoint': 'update.kineticsmart.com',
  'autoupdate.s3-bucket-name': 'goodbox',
  'autoupdate.s3-prefix': 'files',
  'device.name': '',
  'device.show_name': false,
  'footer.line1': '',
  'footer.line2': '',
  'footer.line3': '',
  'footer.line4': '',
  'footer.line5': '',
  'gsm.apn': 'wlapn.com',
  'header.line1': '',
  'header.line2': '',
  'header.line3': '',
  'header.line4': '',
  'header.line5': '',
  'merchant.cashback': false,
  'merchant.cashback_limit': 10000,
  'merchant.client_verification_manual': 'both',
  'merchant.client_verification_swiped': 'none',
  'merchant.country': 'gb',
  'merchant.country_code': '0826',
  'merchant.currency': 'gbp',
  'merchant.currency_code': '0826',
  'merchant.currency_symbol': '£',
  'merchant.industry': 'retail',
  'merchant.logon': false,
  'merchant.manual_limit': 9999999,
  'merchant.merchantid': '',
  'merchant.printable_lines': '15',
  'merchant.process_port': '46463',
  'merchant.process_url': 'ssl9.tnsi.eu.com',
  'merchant.prompt_reference': false,
  'merchant.support_email': 'support@goodbox.com',
  'merchant.support_phone': '0808 196 1808',
  'merchant.swipe_limit': 9999999,
  'merchant.terminal_capabilities': "'contact_emv','mag_stripe','manual_entry','pinpad','response_addl_data','contactless_mag_stripe','contactless_emv','contactless_cdcvm','contactless_signature'",
  'merchant.terminalid': '',
  'merchant.tip_enabled': false,
  'terminal.remove_card_sound': true,
  'terminal.debug': false,
  'terminal.host': 'aibms',
  'terminal.logo': 'gb_logo_black',
  'timezone.region': 'GB-London',
  'goodbox.enabled': true,
  'merchant.max_offline': 1000,
  'donation.mode_offline': true,
  'donation.max_amount': 10000,
  'goodbox.force_offline': true,
  'goodbox.offline_idle': true,
  'goodbox.offline_idle_timer': 30,
  'goodbox.charity_name': 'GoodBox',
  'merchant.no_receipt': true,
  'partner.url': 'http://goodbox-proxy-1590989627.eu-west-2.elb.amazonaws.com/transactions'
}

export const cv3ukapp = settingsCv3ukapp
export const cmp200ukapp = settingsCmp200ukapp
export const cv3ppukapp = settingsCv3ppukapp
export const cmp200gbapp = settingsCmp200gbapp
export const cv3amtukapp = settingsCv3amtukpp
